import React from 'react'
import PropTypes from 'prop-types'
import ModalWrapper from '../../ui/modal/modal-wrapper'
import { selectModalContent } from './utils'

const SelectModal = props => {
  const { onClose, modalType } = props
  return (
    <ModalWrapper onClose={onClose}>
      {selectModalContent(modalType)}
    </ModalWrapper>
  )
}

SelectModal.propTypes = {
  onClose: PropTypes.func,
  modalType: PropTypes.string
}

export default SelectModal



// WEBPACK FOOTER //
// ./src/services/modal/SelectModal.js